<template>
  <PageWrapper :page-data="pageData"
               :brand="brandFromStore">
    <template #header-logo>
      <HeaderLogo />
    </template>
    <template #header-search>
      <HeaderSearch />
    </template>
    <template #header-user-navi>
      <HeaderUserNavi />
    </template>
    <template #footer>
      <PageFooter :brand="brandFromStore"
                  :footer-data="pageData.footer" />
    </template>
    <template #content-top>
      <noscript v-if="isClient"
                class="bx-no-script">
        <strong>Hinweis:</strong> Um unsere Webseite vollständig nutzen zu können, muss JavaScript in Deinem Browser aktiviert sein.<br>
        Viele Funktionen wie das TV-Programm oder die Video-on-Demand-Suche stehen ohne JavaScript nur stark eingeschränkt zur Verfügung.<br>
        <strong>Bitte aktiviere JavaScript in Deinem Browser, um das bestmögliche Nutzungserlebnis zu erhalten.</strong>
      </noscript>
    </template>
  </PageWrapper>
</template>

<script>
import { mapState } from 'pinia'

import { usePageStore } from '../../stores/page'
// these components will be injected into the app via slots
import PageWrapper from '../../components/PageWrapper.vue'
import HeaderUserNavi from './theme/HeaderUserNavi.vue'
import defaultAppInit from '../../mixins/default-app-init'
import clientOnly from '../../mixins/client-only'
import PageFooter from './theme/Footer.vue'
import HeaderLogo from './theme/HeaderLogo.vue'
import HeaderSearch from './theme/HeaderSearch.vue'

export default {
  components: {
    HeaderLogo,
    HeaderUserNavi,
    HeaderSearch,
    PageFooter,
    PageWrapper
  },
  mixins: [defaultAppInit, clientOnly],
  computed: {
    ...mapState(usePageStore, ['pageData', 'brandFromStore'])
  }
}
</script>
